export type AIBillingStatus =
  | "not_configured"
  | "disabled"
  | "blocked"
  | "low_balance"
  | "active";

export type AIBillingErrorKind = "none" | "generic" | "forbidden";

export interface AIBillingPeriodRequest {
  from: string;
  to: string;
}

export interface AIBillingDateRange {
  from?: string;
  to?: string;
}

export interface AIBillingPagedRequest extends AIBillingPeriodRequest {
  page: number;
  pageSize: number;
  sortColumn?: string;
  descending?: boolean;
}

export interface AIBillingExportRequest extends AIBillingPeriodRequest {
  sortColumn?: string;
  descending?: boolean;
}

export interface AIBillingPagedResponse<TItem> {
  itemCount: number;
  page: number;
  pageSize: number;
  sortColumn: string;
  descending: boolean;
  items: TItem[];
  /** El backend evalúa renombrar `items` a `list` para alinearse con el resto
   * de los listados de Intiza (GDC-2995). Se acepta cualquiera de los dos. */
  list?: TItem[];
}

export interface AIBillingDashboardResponse {
  availableUsd: number;
  consumedUsd: number;
  tokensIn: number;
  tokensOut: number;
  status: AIBillingStatus;
  agentEnabled: boolean;
}

/** PENDIENTE DE BACKEND (GDC-2997, punto 4): `/aibilling/dashboard` todavía no
 * devuelve `alertSettings`. La pantalla lo muestra con datos mock hasta que se
 * agregue al response. */
export interface AIBillingAlertSettings {
  enabled: boolean;
  email: string;
  consumedPercentageThreshold: number;
  lastNotifiedAt: string | null;
}

export enum AIAgentType {
  Chat = 1,
  ChatTitle = 2,
  Categorize = 3,
  Review = 4,
  Translate = 5,
  Retenciones = 6,
  Agenda = 7
}

export type AIBillingUsageSortColumn =
  | "CreatedAt"
  | "AgentType"
  | "UserID"
  | "InputTokens"
  | "OutputTokens"
  | "CostUsd";

export type AIBillingPaymentSortColumn =
  | "CreatedAt"
  | "AmountUsd"
  | "Reference"
  | "PublicDescription";

export interface AIBillingUsageItem {
  date: string;
  agentType: AIAgentType | null;
  userId: number;
  tokensIn: number;
  tokensOut: number;
  amount: number | null;
  free: boolean | null | undefined;
}

export interface AIBillingPaymentItem {
  date: string;
  amount: number;
  reference: string | null;
  publicDescription: string | null;
}

export type AIBillingUsageResponse = AIBillingPagedResponse<AIBillingUsageItem>;

export type AIBillingPaymentListResponse =
  AIBillingPagedResponse<AIBillingPaymentItem>;

export type AIBillingUsageListResponse = AIBillingUsageResponse;

export type AIBillingRechargeItem = AIBillingPaymentItem;
